module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-left-8364151a25d5d1c21f68bf14a96fd31d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-left.svg
// module id = ymJg
// module chunks = 24